import actions from '@/store/modules/budget/actions'
import getters from '@/store/modules/budget/getters'
import mutations from '@/store/modules/budget/mutations'
import state from '@/store/modules/budget/state'

export default {
    actions,
    getters,
    mutations,
    state
}